import React from 'react';
import ScrAppBookPricing from './ScrAppBookPricing';

const PublicPricing: React.FC = () => (
  <div className="container-fluid bg-white scrappbook-pricing-page">
    <ScrAppBookPricing
      authentication={{
        digistore: {
          discountKey: {
            first_percent: 20,
            percent: 0
          }
        },
        authenticated: false
      }}
    />
  </div>
);

export default PublicPricing;
